export default {
    "确认": "Confirm",
    "取消": "Cancel",
    "选择语言": "Select Language",
    "切换语言成功": "switched successfully",
    "首页": "Home",
    "申购": "Subscription",
    "团队": "Team",
    "资金管理": "Management",
    "资金明细": "Fund Details",
    "我的订单": "My Orders",
    "订单详情": "Order Details",
    "交易进行中,请勿进行其他操作": "Transaction is in progress, please do not perform other operations",
    "没有更多了": "No more",
    "加载中": "Loading",
    "代币价格": "Token Price",
    "收益概览": "Income Overview",
    "申购收益": "Subscription Income",
    "分享收益": "Sharing Income",
    "官方网站": "Official Website",
    "官网": "Official Site",
    "电报": "Telegram",
    "推特": "Twitter",
    "白皮书": "White Paper",
    "申购金额": "Subscription Amount",
    "请输入入金金额": "Please enter the deposit amount",
    "快捷申购": "Quick Subscription",
    "申购比例": "Subscription Ratio",
    "赠币数量": "Bonus Token Quantity",
    "立即申购": "Subscribe",
    "更多": "More",
    "订单": "Order",
    "分红中": "In Dividend",
    "已完成": "Completed",
    "累计分红": "Cumulative Dividends",
    "申购信息": "Subscription Information",
    "兑换数量": "Exchange Quantity",
    "开始时间": "Start Time",
    "提现成功": "Withdrawal Successful",
    "订单编号": "Order Number",
    "团队数据总览": "Team Data Overview",
    "我的推广链接": "My Promotion Link",
    "复制": "Copy",
    "分享此链接邀请好友加入团队，获取推广奖励": "Share this link to invite friends to join the team and get promotion rewards",
    "团队业绩": "Team Performance",
    "当前等级": "Current Level",
    "今日收益": "Today's Income",
    "团队用户": "Team Users",
    "有效团队": "Effective Team",
    "有效用户": "Effective Users",
    "无效团队": "Invalid Team",
    "直推用户": "Direct Referrals",
    "有效直推": "Valid Direct Referrals",
    "无效直推": "Invalid Referrals",
    "资产余额数据概览": "Asset Balance Overview",
    "提现": "Withdrawal",
    "选中币种": "Selected Currency",
    "提现数量": "Withdrawal Quantity",
    "确认提现": "Confirm Withdrawal",
    "分红收入": "Dividend Income",
    "直推奖励": "Direct Referral Bonus",
    "团队奖励": "Team Reward",
    "全部": "All",
    "收入": "Income",
    "支出": "Expense",
    "请输入正确的金额": "Please enter the correct amount",
    "申购成功": "Subscription successful",
    "申购失败": "Subscription failed",
    "提现成功": "Withdrawal successful",
    "提现失败": "Withdrawal failed",
    "提现信息": "Withdrawal Info",
    "提现币种": "Withdrawal Currency",
    "提现数量": "Withdrawal Amount",
    "请选择币种": "Please select currency",
    "钱包余额不足": "Insufficient wallet balance",
    "余额不足": "Insufficient balance",

    "提现手续费": "Withdrawal fee",
    "间推奖励": "Indirect referral reward",
    "团队奖励": "Team reward",
    "提现失败退还": "Refund for withdrawal failure",
    "ido申购": "IDO subscription",
    "ido申购赠送": "IDO subscription gift",
    "链式去中心化全球点火网络": "Chain Decentralized Ignition Network Global",
    "长期价值": "Long-term value",
    "智能涌现": "Intelligent emergence",
    "协议永生": "Protocol immortality",
    "立即进入": "Enter immediately",
    "大区累计业绩": "Large area cumulative performance",
    "小区累计业绩": "Small area cumulative performance",
    "复制成功": "Copy successful",
    "复制失败": "Copy failed",
    "暂无数据": "No data available",
    "平级奖励": "Peer-level reward",
    "申购金额不能小于":"Subscription amount cannot be less than",
}